<div class="grid">
    <div class="character">
        <img src="assets/images/{{characterName}}.svg"
            alt="{{characterName}}"
            [ngStyle]="{
        width: mobile
          ? characterName == 'hemmo'
            ? '140px'
            : '200px'
          : characterName == 'hemmo'
          ? '180px'
          : '240px'
      }" />
    </div>
    <div class="information">
        <div>
            <p class="mat-headline-6"
                *ngIf="mobile">
                {{ 'error.http.noUsageRight' | blah }}
            </p>
            <h3 *ngIf="!mobile">{{ 'error.http.noUsageRight' | blah }}</h3>
        </div>
        <div>
            <p>{{ 'error.http.noUsageRightDescription' | blah }}</p>
        </div>
        <div class="actions">
            <div class="browse-instructions">
                <button mat-flat-button
                    id="browse-instructions-button"
                    color="primary"
                    (click)="browseInstructions()">
                    {{ 'error.http.tryToBrowseInstead' | blah }}
                </button>
            </div>
        </div>
    </div>
</div>